import { defineMessages } from 'react-intl';

export default defineMessages({

    additionalInterest: {
        id: 'tfpa.policyChange.residential.additionalInfo.Discounts',
        defaultMessage: 'Discounts',
    },
    homeSecurityExplanation: {
        id: 'tfpa.policyChange.residential.discounts.Home Security Explanation',
        defaultMessage: `
        • Exterior doors are solid core doors that are 1 3/8 inches thick and secured by dead-bolt locks.
        • Metal doors must be secured by dead-bolt locks.
        • Double doors meet the specifications for exterior doors and have the inactive door secured by header and threshold bolts that penetrate metal strike plates. 
            In the case of glass located within 40 inches of the header and threshold bolts, have the bolts flush-mounted in the edge of the door.
        • Sliding glass doors are secured by secondary locking devices to prevent lifting and prying.
        • Dutch doors have concealed flush bolt locking devices to interlock upper and lower halves and are secured by a dead-bolt lock.
        • Garage doors are equipped with key operated locking devices.
        • Windows are secured by auxiliary locking devices.
        • Applicants may be eligible for an additional credit if the property is equipped with an electronic burglar alarm and is inspected by a local or county crime 
            prevention unit to certify the property meets the following requirements:
                ◦ all exterior structure openings are contacted; the system includes interior and exterior siren;
                ◦ all equipment is U.L. approved and is monitored by a U.L. approved central station;
                ◦ and sales, service, installation, and monitoring of the system are done in compliance with the Private Investigations and Private Agencies Act (Article 4413 
                (29bb), Vernon's Texas Civil Statures).`,
    },
    automaticSprinklerExplanation: {
        id: 'tfpa.policyChange.residential.discounts.Automatic Sprinkler Explanation',
        defaultMessage: `
        • Please contact Underwriting for additional information.`,
    },
    noPriorLosses: {
        id: 'tfpa.policyChange.residential.discounts.No Prior Losses Found',
        defaultMessage: 'No Prior Losses Found',
    },
    required: {
        id: 'tfpa.policyChange.residential.discounts.This is a required field',
        defaultMessage: 'This is a required field.',
    },
    unableToRetrieve: {
        id: 'tfpa.policyChange.residential.discounts.Unable to retrieve prior loss information',
        defaultMessage: 'Unable to retrieve prior loss information.',
    },
    close: {
        id: 'tfpa.policyChange.residential.discounts.Close',
        defaultMessage: 'Close',
    }
});
